/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 487
// module chunks = 0